export default "__VITE_ASSET__BZJNogph__"